import { useLocation, Navigate } from "react-router-dom";
import TrainingSchool from "./TrainingSchool";
import Conference from "./Conference";
import InMemoryOf from "./InMemoryOf";
import School from "./School";

const dynamicRoutes = [
  { prefix: "/in_memory_of-", component: InMemoryOf, propName: "person_name" },
  { prefix: "/conference-", component: Conference, propName: "id_conference" },
  { prefix: "/training_school-", component: TrainingSchool, propName: "id_training_school" },
  { prefix: "/school-", component: School, propName: "id_school" },

];

const CatchAllHandler = () => {
  const location = useLocation();
  const path = location.pathname;

  for (const route of dynamicRoutes) {
    if (path.startsWith(route.prefix)) {
      const value = path.replace(route.prefix, "");
      const Component = route.component;
      return <Component {...{ [route.propName]: value }} />;
    }
  }

  return <Navigate to="/home" />;
};

export default CatchAllHandler;
